import { takeLatest } from 'redux-saga/effects'
import { MOBILE_URL } from '../actions/type'

function openUrlVroomMobile() {
    window.location.href = '/openVroom'
}

function* detectMobile() {
    yield takeLatest(MOBILE_URL, openUrlVroomMobile)
}

export default detectMobile